// AUTH ROUTES
const LOGIN_ROUTE = "/login";
const LOGOUT_ROUTE = "/logout";
const FORGOT_PASSWORD_ROUTE = "/forgot-password";
const CHECK_YOUR_MAIL = "/check-your-mail";
const SET_NEW_PASSWORD = "/set-new-password";
const TWO_FACTOR_AUTH = "/two-factor-auth";
const PASSWORD_RESET_SUCCESSFUL = "/password-reset-successful";
// NON-AUTH ROUTES
const TEST_ROUTE = "/test";
const NOT_FOUND_ROUTE = "/not-found";
const RESTRICTED_ROUTE = "/restricted";
const DESIGN_SYSTEM_ROUTE = "/ds";
const COMING_SOON_ROUTE = "/coming-soon"
const DASHBOARD = "/dashboard"
const SAMPLES_LIST_ROUTE = '/samples'
const QR_CODE_LIST_ROUTE = '/qrcode-list'
const ACCESSIONING_LIST = '/accessioning-list'
const RESULT_LIST_ROUTE='/result-list'
const SEND_OUT_SESSION_LIST_ROUTE='/sendout-session-list'
const SEND_OUT_SESSION_DETAILS_ROUTE='/sendout-session-details'
const RESULT_PREVIEW_ROUTE='/result-preview'
const TEST_ORDER_LIST_ROUTE = '/testorder-list'
const TEST_ORDER_CREATE_ROUTE = "/test-order-create";
const TEST_LIST_ROUTE = '/test-list';
const TEST_PANEL_LIST_ROUTE = '/test-panel-list';
const PATIENT_LIST_ROUTE = '/patient-list';
const BULK_PATIENT_LIST_ROUTE = '/bulk-patient-list';
const BULK_PATIENT_VIEW_ROUTE = '/bulk-patient-view';
const LOCATION_LIST_ROUTE = '/location-list'
const LOCATION_ADD_ROUTE='/location-add';
const LOCATION_DETAILS_ROUTE = '/location-details'
const LOCATION_DETAILS_TEST_ORDER_ROUTE = '/location-details-test-orders'
const FACILITY_LIST_ROUTE = '/facility-list';
const FACILITY_ADD_ROUTE = '/facility-add'
const FACILITY_DETAILS_LOCATIONS_ROUTE = '/facility-details-locations'
const FACILITY_DETAILS_ROUTE = '/facility-details'
const LAB_LIST_ROUTE = '/lab-list'
const LAB_CREATE_ROUTE = '/lab-create'
const PATIENT_ADD_ROUTE = '/patient-add'
const PATIENT_DETAILS_ROUTE = '/patient-details'
const TEST_ORDER_DETAILS_ROUTE = '/testOrder-details'
const TEST_CREATE_ROUTE = '/test-create'
const TEST_DETAILS_ROUTE = '/test-details'
const LAB_DETAILS_ROUTE='/lab-details'
const BULK_ORDER_LIST_ROUTE = '/bulk-order-list'
const BULK_ORDER_VIEW_ROUTE = '/bulk-order-view'
const STATE_REPORTING_LIST_ROUTE = '/state-reporting-list'
const STATE_REPORTING_VIEW_ROUTE = '/state-reporting-view'
const BARCODES_LIST_ROUTE = '/barcodes-list'
const SYSTEM_SETTINGS_ROUTE = '/system-settings'
const TEST_SAMPLE_ACTIVITY_LOGS_ROUTE = '/test-sample-activity-logs';
const ACCESS_LEVEL_LIST_ROUTE = '/access-level-list';
const INVENTORY_LIST_ROUTE = '/inventory-list';
const INVENTORY_ADD_ROUTE = '/inventory-add';
const INVENTORY_DETAILS_ROUTE = '/inventory-details';
const BIOMARKERS_LIST_ROUTE = '/biomarkers-list';
const OCR_ROUTE = '/ocr';
const ACCESS_LEVEL_ROLE_DETAILS_ROUTE = '/access-level-role-details';
const ACCESS_LEVEL_ADD_ROUTE = '/access-level-add';

const BIOMARKER_ADD_ROUTE = '/biomarker-add';

const BIOMARKER_DETAILS_ROUTE = '/biomarker-details';

const USER_LIST_ROUTE = '/user-list';

const USER_ADD_ROUTE = '/user-add';
const USER_DETAILS_ROUTE = '/user-details';
const SUPPORT_CENTER_ROUTE = '/support-center';
const SIGNATURE_ROUTE = '/signature';
const PRIVACY_POLICY = 'privacy-policy';

const LAB_OS_ROUTE = '/lab-os';

const QUALITY_CONTROL_ROUTE = '/lab-os/quality-control';

const QUALITY_ASSURANCE_ROUTE = '/lab-os/quality-assurance';

const INVENTORY_MANAGEMENT_ROUTE = '/lab-os/inventory-management';
const SOP_ROUTE = '/lab-os/sop-validation';
const HR_EMPLOYEE_DOCUMENTS_ROUTE = '/lab-os/hr-employee-documents';

const INSTRUMENT_ROUTE = '/lab-os/instrument';

const LABOS_DEPARTMENTS_ROUTE = '/lab-os/departments';

const LABOS_EQUIPMENT_ROUTE = '/lab-os/equipment';

const LABOS_STORAGE_ROUTE = '/lab-os/storage';
const FORMS_ROUTE = '/lab-os/forms';

const PLATES_ROUTE = '/lab-os/plates';

const LABOS_CALCULATIONS_ROUTE = '/lab-os/calculations';

const LABOS_REPORTS_ROUTE = '/lab-os/reports';
const GUEST_ROUTES = [NOT_FOUND_ROUTE, DESIGN_SYSTEM_ROUTE, LOGIN_ROUTE];

export {
    LOGIN_ROUTE,
    LOGOUT_ROUTE,
    COMING_SOON_ROUTE,
    NOT_FOUND_ROUTE,
    GUEST_ROUTES,
    TEST_ROUTE,
    DESIGN_SYSTEM_ROUTE,
    SAMPLES_LIST_ROUTE,
    ACCESSIONING_LIST,
    RESULT_LIST_ROUTE,
    TEST_ORDER_LIST_ROUTE,
    TEST_LIST_ROUTE,
    TEST_ORDER_DETAILS_ROUTE,
    LOCATION_LIST_ROUTE,
    LOCATION_ADD_ROUTE,
    PATIENT_LIST_ROUTE,
    BULK_PATIENT_LIST_ROUTE,
    BULK_PATIENT_VIEW_ROUTE,
    FACILITY_LIST_ROUTE,
    FACILITY_ADD_ROUTE,
    LAB_LIST_ROUTE,
    LAB_CREATE_ROUTE,
    LAB_DETAILS_ROUTE,
    RESULT_PREVIEW_ROUTE,
    TEST_ORDER_CREATE_ROUTE,
    PATIENT_ADD_ROUTE,
    DASHBOARD,
    PATIENT_DETAILS_ROUTE,
    SEND_OUT_SESSION_LIST_ROUTE,
    SEND_OUT_SESSION_DETAILS_ROUTE,
    RESTRICTED_ROUTE,
    TEST_DETAILS_ROUTE,
    FACILITY_DETAILS_LOCATIONS_ROUTE,
    QR_CODE_LIST_ROUTE,TEST_CREATE_ROUTE,
    FACILITY_DETAILS_ROUTE,
    LOCATION_DETAILS_TEST_ORDER_ROUTE,
    LOCATION_DETAILS_ROUTE,
    BULK_ORDER_LIST_ROUTE,
    BULK_ORDER_VIEW_ROUTE,
    STATE_REPORTING_LIST_ROUTE,
    STATE_REPORTING_VIEW_ROUTE,
    BARCODES_LIST_ROUTE,
    SYSTEM_SETTINGS_ROUTE,
    TEST_SAMPLE_ACTIVITY_LOGS_ROUTE,
    ACCESS_LEVEL_LIST_ROUTE,
    ACCESS_LEVEL_ROLE_DETAILS_ROUTE,
    OCR_ROUTE,
    INVENTORY_LIST_ROUTE,
    INVENTORY_ADD_ROUTE,
    INVENTORY_DETAILS_ROUTE,
    ACCESS_LEVEL_ADD_ROUTE,
    FORGOT_PASSWORD_ROUTE,
    CHECK_YOUR_MAIL,
    SET_NEW_PASSWORD,
    TWO_FACTOR_AUTH,
    PASSWORD_RESET_SUCCESSFUL,
    BIOMARKERS_LIST_ROUTE,
    BIOMARKER_ADD_ROUTE,
    BIOMARKER_DETAILS_ROUTE,
    TEST_PANEL_LIST_ROUTE,
    USER_LIST_ROUTE,
    USER_ADD_ROUTE,
    USER_DETAILS_ROUTE,
    SUPPORT_CENTER_ROUTE,
    SIGNATURE_ROUTE,
    PRIVACY_POLICY,
    LAB_OS_ROUTE,
    QUALITY_CONTROL_ROUTE,
    QUALITY_ASSURANCE_ROUTE,
    INVENTORY_MANAGEMENT_ROUTE,
    SOP_ROUTE,
    HR_EMPLOYEE_DOCUMENTS_ROUTE,
    INSTRUMENT_ROUTE,
    FORMS_ROUTE,
    LABOS_DEPARTMENTS_ROUTE,
    LABOS_EQUIPMENT_ROUTE,
    LABOS_STORAGE_ROUTE,
    PLATES_ROUTE,
    LABOS_CALCULATIONS_ROUTE,
    LABOS_REPORTS_ROUTE
}
